import { isObject, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { AudioContainerType } from "./audio/AudioFormat.js";
import { VideoContainerType } from "./video/VideoFormat.js";

/**
 * questo è il tipo dell'enumerativo che continene tutti i tipi di container media gestiti
 */
export type MediaContainerType = AudioContainerType | VideoContainerType 


/**
 * dati grezzi (provenienti da server) con le informazioni di formato del media
 */
export interface MediaFormatRawData {

    container: MediaContainerType,
    resourceUrl: string    
};

/**
 * barrier per oggetti di tipo MediaFormatRawData
 * @param obj l'oggetto da verificare
 * @returns 
 */
export function isMediaFormatRawData(obj: any): obj is MediaFormatRawData {
    return isObject(obj) &&
        hasOwnProperty(obj,'container') &&
        hasOwnProperty(obj,'resourceUrl') &&
        isString(obj['resourceUrl']);
};
